import * as yup from 'yup'

export const usernameFieldSchema = yup
  .string()
  .required('Username is required')
  .min(3, 'Username must be at least 3 characters')
  .max(30, 'Username must be at most 30 characters')
  .test('no-email', 'Email cannot be used as username', (value) => !value?.includes('@'))

export const usernameSchema = yup.object().shape({ username: usernameFieldSchema }).required()

export type UsernameFormValues = yup.InferType<typeof usernameSchema>
